import { render, staticRenderFns } from "./PromptUpdateOtherFaresModal.vue?vue&type=template&id=230e08e2&"
import script from "./PromptUpdateOtherFaresModal.vue?vue&type=script&lang=js&"
export * from "./PromptUpdateOtherFaresModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports